<template>
  <div id="deviceinfo">
    <div class="top">
      <div class="back" ref="back" @click="back">{{ $t("index.back") }}</div>
      {{ deviceInfo.warnType }}：{{ deviceInfo.warn }}
    </div>
    <div class="infocontent">
      <div class="left">
        <div class="card" id="info">
          <div class="card-head">
            <div>{{ $t("index.deviceInfo") }}</div>
            <div>No.{{ deviceInfo.id }}</div>
          </div>
          <div class="card-content">
            <!-- 左上组件 -->
            <InfoComponent :key="datekey" :devicein="deviceInfo" />
          </div>
        </div>
        <div class="card" id="taskinfo" v-if="deviceInfo.deviceType == 'tube'">
          <div class="card-head">
            <div>{{ $t("index.workInfo") }}</div>
            <div>id：{{ deviceInfo.taskId }}</div>
          </div>
          <div class="card-content">
            <!-- 左下管机组件 -->
            <TaskInfoTube :devicein="deviceInfo" />
          </div>
        </div>
        <div class="card" id="taskinfo" v-else>
          <div class="card-head">
            <div>{{ $t("index.workInfo") }}</div>
            <div>id：{{ deviceInfo.taskId }}</div>
          </div>
          <div class="card-content">
            <!-- 左下板机组件 -->
            <TaskInfo :devicein="deviceInfo" />
          </div>
        </div>
        <!--         <div class="line">
          <div class="card" id="hours">
            <div class="card-head">
              <div>{{ $t("index.workTime") }}</div>
              <div class="datebox">
                {{ $t("index.selectDay") }}：
                <VueDatePicker class="datepicker" v-model="date1"></VueDatePicker>
              </div>
            </div>
            <div class="card-content">
              <HoursComponent :deviceId="deviceInfo.id" />
            </div>
          </div>
          <div class="card" id="hoursline">
            <div class="card-head">
              <div>{{ $t("index.workWeek") }}</div>
              <div class="datebox">
                {{ $t("index.selectWeek") }}：
                <VueDatePicker
                  class="datepicker"
                  v-model="date2"
                  week-picker
                ></VueDatePicker>
              </div>
            </div>
            <div class="card-content">
              <HoursLine :deviceId="deviceInfo.id" />
            </div>
          </div>
        </div>
        <div class="card" id="repairreport">
          <div class="card-head">
            <div>{{ $t("index.repair") }}</div>
          </div>
          <div class="card-content">
            <RepairReport :deviceId="deviceInfo.id" />
          </div>
        </div> -->
      </div>
      <div class="right">
        <div class="card" id="task">
          <div class="card-head">
            <div>{{ $t("index.deviceMonitor") }}</div>
            <div>{{ $t("index.workedTime") }}：{{ deviceInfo.workedTime }}</div>
          </div>
          <div class="card-content">
            <!-- 右上组件 -->
            <TaskComponent :key="datekey" :devicein="deviceInfo" />
          </div>
        </div>
        <div class="card" id="realtime">
          <div class="card-head">
            <div>{{ $t("index.realTime") }}</div>
          </div>
          <div class="card-content">
            <!-- 右下组件 -->
            <RealtimeData :key="datekey" :devicein="deviceInfo" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import InfoComponent from "./DevicePage/BasicInfo.vue";
import TaskComponent from "./DevicePage/DeviceTask.vue";
import TaskInfoTube from "./DevicePage/TaskInfo_tube.vue";
import HoursComponent from "./DevicePage/RunHours.vue";
import HoursLine from "./DevicePage/HoursLine.vue";
import RealtimeData from "./DevicePage/RealtimeData.vue";
import TaskInfo from "./DevicePage/TaskInfo.vue";
import RepairReport from "./DevicePage/RepairReport.vue";

import { message } from "ant-design-vue";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
/* import * as mqtt from "mqtt/dist/mqtt.min"; */
import "@/mqttws31.min";

let datekey = Date.now();

let deviceInfo = ref({
  id: "1",
  orderNumber: "",
  name: "设备1",
  deviceType: "sheet",
  state: "2",
  task: "test",
  schedule: 0,
  x: "0",
  y: "0",
  z: "0",
  workedTime: "00:00:00",
  warnType: "",
  warn: "",
  taskFile: "E:bdproj",
  taskId: "114514",
  cutLeng: 0,
  emptyLength: 0,
  percent: "0%",
  left: 100,
  speed: 0,
  power: 0,
  pressure: 0,
  pierceCount: 0,
  pierceTime: 0,
  cutTime: 16457,
  partCount: 0,
});

const router = useRouter();
let route = useRoute();
let orderNumber = route.params.orderNumber;

let offInterval = null;

/**初始化mqtt连接参数 */
var hostname = "mqtt.bodor.com"; //链接地址
var port = 8084; //端口号
var clientId = "client-" + Date.now(); //id
var timeout = 5;
var keepAlive = 100;
var cleanSession = false;
var ssl = true; //true的时候连接wss，否则连接ws
var topic = route.params.orderNumber; //设备的orderNumber
var client = new Paho.MQTT.Client(hostname, port, clientId); //定义mqtt连接，后续回调函数都在这上面调用
//建立客户端实例
var options = {
  invocationContext: {
    host: hostname,
    port: port,
    path: client.path,
    clientId: clientId,
  },
  timeout: timeout,
  keepAliveInterval: keepAlive,
  cleanSession: cleanSession,
  useSSL: ssl,
  userName: "admin",
  password: "bodor2024",
  onSuccess: onConnect,
  onFailure: function (e) {
    message.error(e.errorMessage);
  },
};

if (route.params.orderNumber) {
  axios
    .post("api/Machine/GetMachineTables", {
      OrderNumber: route.params.orderNumber,
    })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        let res = response.data.ReturnData[0];
        deviceInfo.value.id = res.EquipmentId;
        deviceInfo.value.name = res.orderNumber;
        deviceInfo.value.deviceType = route.params.type;
        deviceInfo.value.orderNumber = route.params.orderNumber;
        console.log(deviceInfo.value.deviceType);

        /**当你拿到了orderNumber，就可以开始连接了 */
        client.connect(options);

        client.onConnectionLost = onConnectionLost;

        //注册连接断开处理事件
        client.onMessageArrived = onMessageArrived;
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

/* if (history.state.data) {
  const equipmentData = JSON.parse(history.state.data);
  deviceInfo.value.id = equipmentData.equipmentid;
  deviceInfo.value.name = equipmentData.name;
  deviceInfo.value.deviceType = equipmentData.deviceType;
  deviceInfo.value.ordernumber = equipmentData.ordernumber;

  var hostname = "mqtt.bodor.com";
  var port = 8084; //这里就是第二步配置的port8083
  var clientId = "client-" + Date.now();
  var timeout = 5;
  var keepAlive = 100;
  var cleanSession = false;
  var ssl = true;
  var topic = deviceInfo.value.ordernumber;
  var client = new Paho.MQTT.Client(hostname, port, clientId);
  //建立客户端实例
  var options = {
    invocationContext: {
      host: hostname,
      port: port,
      path: client.path,
      clientId: clientId,
    },
    timeout: timeout,
    keepAliveInterval: keepAlive,
    cleanSession: cleanSession,
    useSSL: ssl,
    userName: "admin",
    password: "bodor2024",
    onSuccess: onConnect,
    onFailure: function (e) {
      message.error(e.errorMessage);
    },
  };
  client.connect(options);

  client.onConnectionLost = onConnectionLost;

  //注册连接断开处理事件
  client.onMessageArrived = onMessageArrived;
} */

//连接服务器并注册连接成功处理事件
function onConnect() {
  console.log("onConnected");
  //订阅频道，频道主题就是设备的orderNumber，后续会自动往这发数据
  client.subscribe(topic);
}

//注册消息接收处理事件
function onConnectionLost(responseObject) {
  console.log(responseObject);
  if (responseObject.errorCode !== 0) {
    console.log("onConnectionLost:" + responseObject.errorMessage);
    console.log("连接已断开");
  }
}

//收到消息时自动触发的回调函数
function onMessageArrived(message) {
  console.log(message);

  //心跳检测，如果三秒内没收到新消息自动离线，这个offlineData()是我写的调整设备状态离线的函数，记得事先定义一个offInterval为null
  if (offInterval) {
    clearInterval(offInterval);
  }
  offInterval = setInterval(function () {
    offlineData();
    datekey = Date.now();
  }, 3000);

  let messageJSON = JSON.parse(message.payloadString);
  handleData(messageJSON);
}

//应该是没有用
function send() {
  message = new Paho.MQTT.Message(s);
  message.destinationName = topic;
  client.send(message);
}

var count = 0;

//应该是没有用
function start() {
  window.tester = window.setInterval(function () {
    if (client.isConnected) {
      var s =
        "{time:" +
        new Date().Format("yyyy-MM-dd hh:mm:ss") +
        ", content:" +
        count++ +
        ", from: web console}";
      message = new Paho.MQTT.Message(s);
      message.destinationName = topic;
      client.send(message);
    }
  }, 1000);
}

//应该是没有用
function stop() {
  window.clearInterval(window.tester);
}

//应该是没有用
Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

/* const connection = ref({
  url: "ws://172.18.0.237:8083/mqtt",
  clean: true,
  rejectUnauthorized: false, // 忽略SSL证书验证
  connectTimeout: 30 * 1000, // ms
  reconnectPeriod: 4000, // ms
  clientId: "client-test",
  // auth
  username: "admin",
  password: "123456",
});

const subscription = ref({
  topic: "topic/mqttx",
  qos: 0,
});
const publish = ref({
  topic: "topic/browser",
  qos: 0,
  payload: '{ "msg": "Hello, I am browser." }',
});
const receiveNews = ref("");
const qosList = ref([0, 1, 2]);
const client = ref({
  connected: false,
});
const subscribeSuccess = ref(false);
const connecting = ref(false);
const retryTimes = ref(0);
onMounted(() => {
  createConnection();
});

const initData = () => {
  client.value = { connected: false };
  retryTimes.value = 0;
  connecting.value = false;
  subscribeSuccess.value = false;
};
const handleOnReConnect = () => {
  retryTimes.value += 1;
  if (retryTimes.value > 5) {
    try {
      this.client.end();
      initData();
      message.error("Connection maxReconnectTimes limit, stop retry");
    } catch (error) {
      message.error(error.toString());
    }
  }
};

const createConnection = () => {
  try {
    connecting.value = true;
    const { url, ...options } = connection.value;
    client.value = mqtt.connect(url, options);
    if (client.value.on) {
      client.value.on("connect", () => {
        connecting.value = false;
        console.log("Connection succeeded!");
      });
      client.value.on("reconnect", handleOnReConnect());
      client.value.on("error", (error) => {
        console.log("Connection failed", error);
      });
      client.value.on("message", (topic, message) => {
        receiveNews.value = receiveNews.value.concat(message);
        console.log(`Received message ${message} from topic ${topic}`);
      });
    }
  } catch (error) {
    connecting.value = false;
    console.log("mqtt.connect error", error);
  }
};
const doSubscribe = () => {
  const { topic, qos } = subscription.value;
  client.value.subscribe(topic, { qos }, (error, res) => {
    if (error) {
      console.log("Subscribe to topics error", error);
      return;
    }
    subscribeSuccess.value = true;
    console.log("Subscribe to topics res", res);
  });
};
// unsubscribe topic
const doUnSubscribe = () => {
  const { topic } = subscription.value;
  client.value.unsubscribe(topic, (error) => {
    if (error) {
      console.log("Unsubscribe error", error);
    }
  });
};
// publish message
const doPublish = () => {
  const { topic, qos, payload } = publish.value;
  client.value.publish(topic, payload, { qos }, (error) => {
    if (error) {
      console.log("Publish error", error);
    }
  });
};
// disconnect
const destroyConnection = () => {
  if (client.value.connected) {
    try {
      client.value.end(false, () => {
        initData();
        console.log("Successfully disconnected!");
      });
    } catch (error) {
      console.log("Disconnect failed", error.toString());
    }
  }
};
const handleProtocolChange = (value) => {
  connection.value.port = value === "wss" ? "8084" : "8083";
}; */

const test = [
  { KEY: "bodor_NowTime", VALUE: "2023/12/14 9:12:04" },
  { KEY: "bodor_MachineId", VALUE: "6500004562" },
  { KEY: "bodor_TaskName", VALUE: "无" },
  { KEY: "bodor_TaskId", VALUE: "NoTaskID" },
  {
    KEY: "bodor_WorkFile",
    VALUE:
      "E:\\PCNC\\plate\\hmi\\BodorThinker5.0-10000W\\bin\\Debug\\BtNestSystem\\zipfile\\processfile\\Geometry2D\\processfile.bdproj",
  },
  { KEY: "bodor_SystemState", VALUE: "离线" },
  { KEY: "bodor_ProcessingProgress", VALUE: "0" },
  { KEY: "bodor_LeftProgress", VALUE: "100" },
  { KEY: "bodor_X", VALUE: "0" },
  { KEY: "bodor_Y", VALUE: "0" },
  { KEY: "bodor_Z", VALUE: "0" },
  { KEY: "bodor_FeedRate", VALUE: "0" },
  { KEY: "bodor_FeedSpeed", VALUE: "0" },
  { KEY: "bodor_CutPressure", VALUE: "0" },
  { KEY: "bodor_Power", VALUE: "0" },
  { KEY: "bodor_NulldisplacementLength", VALUE: "0" },
  { KEY: "bodor_CutLength", VALUE: "0" },
  { KEY: "bodor_ProcessingTime", VALUE: "00:00:00" },
  { KEY: "bodor_ErrorContent", VALUE: "" },
  { KEY: "bodor_ErrorType", VALUE: "" },
  { KEY: "bodor_ProcessingtimeLength", VALUE: "00:00:00" },
  { KEY: "bodor_IdleTime", VALUE: "00:00:00" },
];

/* let timer = setTimeout(() => {
  handleData(test);
}, 3000); */

function offlineData() {
  /*   deviceInfo.value = {
    id: "1",
    orderNumber: "",
    name: "设备1",
    deviceType: "sheet",
    state: "2",
    task: "test",
    schedule: 0,
    x: "0",
    y: "0",
    z: "0",
    workedTime: "00:00:00",
    warnType: "",
    warn: "",
    taskFile: "E:bdproj",
    taskId: "114514",
    cutLeng: 0,
    emptyLength: 0,
    percent: "0%",
    left: 100,
    speed: 0,
    power: 0,
    pressure: 0,
  }; */
  deviceInfo.value.state = "2";
  deviceInfo.value.task = "";
  deviceInfo.value.schedule = 0;
  deviceInfo.value.x = "0";
  deviceInfo.value.y = "0";
  deviceInfo.value.z = "0";
  deviceInfo.value.workedTime = "00:00:00";
  deviceInfo.value.warnType = "";
  deviceInfo.value.warn = "";
  deviceInfo.value.taskFile = "";
  deviceInfo.value.taskId = "";
  deviceInfo.value.cutLeng = 0;
  deviceInfo.value.emptyLength = 0;
  deviceInfo.value.percent = "0%";
  deviceInfo.value.left = 100;
  deviceInfo.value.speed = 0;
  deviceInfo.value.power = 0;
  deviceInfo.value.pressure = 0;
  deviceInfo.value.pierceCount = 0;
  deviceInfo.value.pierceTime = 0;
}

function handleData(test) {
  if (test.length > 0) {
    test.map((data) => {
      if (data.KEY == "bodor_SystemState") {
        deviceInfo.value.state =
          data.VALUE == "运行"
            ? "0"
            : data.VALUE == "空闲"
            ? "1"
            : data.VALUE == "离线"
            ? "2"
            : "3";
      }
      if (data.KEY == "bodor_TaskName") {
        deviceInfo.value.task = data.VALUE == "" ? "空" : data.VALUE;
      }
      if (data.KEY == "bodor_TaskName") {
        deviceInfo.value.task = data.VALUE == "" ? "空" : data.VALUE;
      }
      if (data.KEY == "bodor_ProcessingProgress") {
        deviceInfo.value.schedule = parseFloat(data.VALUE);
      }
      if (data.KEY == "bodor_X") {
        deviceInfo.value.x = data.VALUE == "" ? "空" : Math.floor(parseFloat(data.VALUE));
      }
      if (data.KEY == "bodor_Y") {
        deviceInfo.value.y = data.VALUE == "" ? "空" : Math.floor(parseFloat(data.VALUE));
      }
      if (data.KEY == "bodor_Z") {
        deviceInfo.value.z = data.VALUE == "" ? "空" : Math.floor(parseFloat(data.VALUE));
      }
      if (data.KEY == "bodor_ProcessingTime") {
        deviceInfo.value.workedTime = data.VALUE == "" ? "空" : data.VALUE;
      }
      if (data.KEY == "bodor_ErrorType") {
        deviceInfo.value.warnType = data.VALUE;
      }
      if (data.KEY == "bodor_ErrorContent") {
        deviceInfo.value.warn = data.VALUE == "" ? "空" : data.VALUE;
      }
      if (data.KEY == "bodor_WorkFile") {
        deviceInfo.value.taskFile = data.VALUE;
      }
      if (data.KEY == "bodor_TaskId") {
        deviceInfo.value.taskId = data.VALUE == "" ? "空" : data.VALUE;
      }
      if (data.KEY == "bodor_CutLength") {
        deviceInfo.value.cutLeng =
          data.VALUE == "" ? "空" : Math.floor(parseFloat(data.VALUE));
      }
      if (data.KEY == "bodor_NulldisplacementLength") {
        deviceInfo.value.emptyLength =
          data.VALUE == "" ? "空" : Math.floor(parseFloat(data.VALUE));
      }
      if (data.KEY == "bodor_FeedRate") {
        deviceInfo.value.percent = data.VALUE == "" ? "空" : data.VALUE + "%";
      }
      if (data.KEY == "bodor_LeftProgress") {
        deviceInfo.value.left = parseFloat(data.VALUE);
      }
      if (data.KEY == "bodor_FeedSpeed") {
        deviceInfo.value.speed = Math.floor(parseFloat(data.VALUE));
      }
      if (data.KEY == "bodor_Power") {
        deviceInfo.value.power = Math.floor(parseFloat(data.VALUE)) / 1000;
      }
      if (data.KEY == "bodor_CutPressure") {
        deviceInfo.value.pressure = Math.floor(parseFloat(data.VALUE));
      }
      if (data.KEY == "bodor_CurrentPierceCount") {
        deviceInfo.value.pierceCount = parseFloat(data.VALUE);
      }
      if (data.KEY == "bodor_CurrentPierceTime") {
        deviceInfo.value.pierceTime = parseFloat(data.VALUE);
      }
      if (data.KEY == "bodor_CurrentCutTime") {
        deviceInfo.value.cutTime = parseFloat(data.VALUE);
      }
      if (data.KEY == "bodor_PartCount") {
        deviceInfo.value.partCount = Math.floor(parseFloat(data.VALUE));
      }
    });
  }
  datekey = Date.now();
}

const date1 = ref();
const date2 = ref();

onBeforeUnmount(() => {
  console.log("aaa");
  client.disconnect();
  if (client) {
    client = null;
  }
});

const back = () => {
  router.push("/index/device");
};
</script>

<style scoped>
#deviceinfo {
  width: 100%;
  height: 100%;
  padding: 0px 0px;
  background-color: #f7f9fa;
  position: relative;
}
.top {
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background-color: white;
  color: black;
  font-weight: bold;
  font-size: 18px;
  position: relative;
  color: #fac858;
}
.back {
  height: 100%;
  line-height: 50px;
  color: #5470c6;
  cursor: pointer;
  position: absolute;
  left: 25px;
}
.infocontent {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 25px 10px 25px 25px;
}
.left {
  width: 49.5%;
}
.right {
  width: 49.5%;
}
.line {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin-bottom: 15px;
  height: auto;
  overflow: visible;
  transition: all 0.4s;
  font-size: 14px;
  background-color: white;
  min-width: 450px;
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}
.card-content {
  width: 100%;
  min-height: 50px;
  padding: 15px;
}
.datebox {
  height: 100%;
  display: flex;
  align-items: center;
}
.datepicker {
  width: 200px;
  height: 30px;
  cursor: pointer;
  background-color: white;
  background-image: none;
  border-radius: 4px;
  position: relative;
}
p {
  margin: 0px;
}
#hours {
  width: 49%;
  height: 380px;
}
#hoursline {
  width: 49%;
  height: 380px;
}
#realtime {
  /* min-width: 900px; */
  /* height: 380px; */
}
#taskinfo {
  /* height: 275px; */
}
#repairreport {
  height: 275px;
}
#repairreport .card-content {
  height: 275px;
  padding: 0px 15px;
}
</style>
